import { SxProps, Theme } from '@mui/system';

const style = {
  root: {
    border: '1px solid #a5b0c4',
    padding: '24px',
    margin: '32px 0px 32px 0px',
    alignSelf: 'start',
    minHeight: 182,
  },
  emptyRoot: {
    border: 'none',
  },

  title: {
    color: 'grey.500',
    fontSize: 16,
    fontWeight: 600,
    paddingBottom: '12px',
  },

  container: {
    color: 'grey.800',
    marginBottom: '8px',
  },

  label: {
    fontWeight: 500,
    fontSize: 16,
  },

  value: {
    fontSize: 16,
    fontWeight: 600,
    // textAlign: 'right',
  },

  note: {
    fontSize: 16,
    mb: '30px',
    color: 'grey.800',
    fontWeight: 400,
  },
} satisfies Record<string, SxProps<Theme>>;

export default style;
